<template>
    <div>

        <config-main-title>
            Combo de Procedimentos
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6">
                    <az-input 
                        ref="pesquisa" 
                        icon="fas fa-search fa-fw" 
                        v-model="search" 
                        @input="selecionado = null"
                        @onArrowDown="onArrowDown"
                        @onArrowUp="onArrowUp"
                        @onEnter="onEnter">
                        <template v-slot:buttonposb>
                            <importacao service="pacotes" @refresh="load()" />
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Combo
                    </button>
                </div>
            </div>

        </div>

        <template v-if="!em_edicao">

            <div v-if="!lista || !lista.length">
                <az-empty-state 
                    msg="Nenhum combo de procedimentos identificado." 
                    icon="fas fa-search"
                    action="Incluir Combo" 
                    :method="incluir" />
            </div>

            <div v-if="!em_edicao && lista && lista.length">

                <div class="list-group mb-3 az-anime-surgir mb-3">
                    <li class="list-group-item d-flex justify-content-between hover-bg" 
                        :class="( id === selecionado ? 'active' : '' )"
                        v-for="(dado, id) in lista" :key="id">
                        <div>
                            <h5 class="mb-0">
                                <span class="badge badge-secondary mr-3"
                                    data-toggle="tooltip" data-placement="top" title="Procedimentos">
                                    {{ dado.procedimento_pacotes_count }}
                                </span>
                                <a href="#" @click.prevent="editar(dado)" class="card-link mb-0 mr-3"
                                    :class="( id === selecionado ? 'text-white' : '' )">
                                    {{ dado.search }}
                                </a>
                                <span class="badge badge-secondary small ml-1">
                                    #{{ dado.id_pacote }}
                                </span>

                                <span class="ml-3" v-if="dado.unidades && dado.unidades.length">
                                    <span class="badge badge-light small ml-1" v-for="(unidade, iux) in dado.unidades" :key="iux" :title="unidade.unidade.st_nome">
                                        {{ unidade.unidade.st_sigla ? unidade.unidade.st_sigla : unidade.unidade.st_nome }}
                                    </span>
                                </span>
                            </h5>
                        </div>
                        <span>
                            <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input" 
                                    :id="'ativo-' + id" 
                                    v-model="dado.fl_ativo" 
                                    @change="toggle(dado)">
                                <label class="custom-control-label" :for="'ativo-' + id"></label>
                            </div>
                            <div v-else class="d-flex">
                                <div v-if="dado.procedimento && dado.procedimento.js_classes && dado.procedimento.js_classes.length" class="mr-2">
                                    <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                                            v-for="(tag, itx) in dado.procedimento.js_classes" :key="itx">
                                        <span class="badge badge-success mr-2">
                                            {{ tag }}
                                        </span>
                                    </a>
                                </div>

                                <div>
                                    <span class="badge badge-secondary mr-3" v-if="dado.fl_combo_pacote">
                                        Pacote
                                    </span>
                                </div>

                                <!-- Menu de opções -->
                                <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2">
                                    <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-ellipsis-v"></i>
                                    </a>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <button class="dropdown-item" :disabled="!dado.fl_ativo" @click="clonar_combo(dado)">
                                            Clonar Combo
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </span>
                    </li>
                </div>

            </div>

            <az-wiki topic="Pacote" />

        </template>

        <!--
        <pre class="alert alert-secondary">{{ lista }}</pre>
        <pre class="alert alert-warning">{{ dados }}</pre>
        -->
        
        <!-- Formulário de edição de pacote de sessão -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            <span v-if="item">
                                {{ item && item.id_pacote ? '' : 'Novo' }}
                            </span>
                            Combo de Procedimentos
                            <span v-if="item && item.id_pacote" class="badge badge-secondary ml-2">
                                #{{ item.id_pacote }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="!item">
                            <az-empty-state />
                        </template>

                        <template v-else>
                            <div class="form-row">
                                <div class="col col-12 col-md-8">
                                    <az-input
                                        sizing="sm"
                                        label="Nome do Combo de Procedimentos"
                                        required 
                                        :validate="validate"
                                        v-model="item.procedimento.st_procedimento" />
                                </div>

                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="Sigla"
                                        :validate="validate"
                                        v-model="item.procedimento.st_sigla" />
                                </div>

                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="Id Externo"
                                        :validate="validate"
                                        v-model="item.procedimento.st_id_externo" />
                                </div>
                            </div>

                            <div class="form-row mb-3">
                                <div class="col col-12 col-md-6">
                                    <az-input 
                                        sizing="sm"
                                        label="Especialidade"
                                        type="select" 
                                        optionsMode="esp-ativas"
                                        optionsName="esp-ativas"
                                        optionsData="id_especialidade"
                                        :optionsReload="true"
                                        required 
                                        :validate="validate"
                                        v-model="item.procedimento.id_especialidade"
                                        @input="carregar_medicos(item)" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input 
                                        sizing="sm"
                                        label="Classificação" 
                                        type="select"
                                        optionsData="id_classe_procedimento"
                                        service="classe_procedimentos.index"
                                        optionsMode="aql"
                                        v-model="item.procedimento.id_classe_procedimento" 
                                        required 
                                        :validate="validate"/>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        label="Marcar Combo?"
                                        type="checkbox-group"
                                        :validate="validate"
                                        v-model="item.pode_marcar" /> 
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        label="Pacote de Procedimentos"
                                        type="checkbox-group"
                                        :validate="validate"
                                        v-model="item.fl_combo_pacote" />
                                </div>
                            </div>

                            <div class="form-row" v-if="item.pode_marcar && !item.fl_combo_pacote">
                                <div class="col col-12 col-md-6" >
                                    <az-input
                                        sizing="sm"
                                        label="Marcação Independente dos Procedimentos"
                                        type="checkbox-group"
                                        :validate="validate"
                                        v-model="item.fl_marcacao_combinada" />
                                </div>
                                <div class="col col-12 col-md-6" >
                                    <az-input
                                        sizing="sm"
                                        label="Autorização Independente dos Procedimentos"
                                        type="checkbox-group"
                                        :validate="validate"
                                        v-if="!item.fl_marcacao_combinada"
                                        v-model="item.fl_autoriz_combinada" />
                                </div>
                            </div>

                            <div class="form-row" v-if="item.fl_combo_pacote">
                                <div class="col col-12 col-md-6" >
                                    <az-input
                                        sizing="sm"
                                        label="Cobrança do Pacote"
                                        type="checkbox-group"
                                        :validate="validate"
                                        v-model="item.fl_cobranca_total" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        label="Particular"
                                        type="checkbox-group"
                                        :validate="validate"
                                        v-model="item.fl_particular" />
                                </div>
                            </div>

                            <div class="form-row" v-if="item.fl_combo_pacote">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        label="Validade em dias"
                                        placeholder="dias..."
                                        type="number"
                                        :validate="validate"
                                        v-model="item.in_validade_dias">
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        label="Valor"
                                        type="money"
                                        v-if="item.fl_particular"
                                        :validate="validate"
                                        v-model="item.dc_valor">
                                    </az-input>
                                </div>
                            </div>

                            <template v-if="!item.fl_particular">

                                <az-sub-title class="mt-2" title="Operadoras" />

                                <div class="form-row">
                                    
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            sizing="sm"
                                            name="operadora-pacote"
                                            icon="fas fa-plus"
                                            type="select"
                                            optionsMode="aql"
                                            :optionsParm="{ fatura: true }"
                                            service="operadoras.index"
                                            v-model="pacoteNovaOperadora"
                                            @input="adicionarOperadora ()" />
                                    </div>

                                    <div class="col col-12 col-md-4" v-for="(po, ipo) in item.pacote_operadoras" :key="ipo">
                                        <az-input 
                                            sizing="sm"
                                            type="checkbox-group"
                                            :label="po.search"
                                            v-model="po.selecionado" />
                                    </div>

                                    <div class="col col-12 col-md-4" v-if="!item.pacote_operadoras || !item.pacote_operadoras.length">
                                        <az-input 
                                            sizing="sm" 
                                            :edicao="false"
                                            value="Todas" />
                                    </div>

                                </div>

                            </template>

                            <div class="form-row">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        class="mt-3"
                                        type="checkbox-group"
                                        label="Definir Cobertura"
                                        :edicao="!( item.filtros && item.filtros.length ) && !( lista_procedimentos.length )"
                                        v-model="item.fl_definir_cobertura" />

                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Apenas no Atendimento"
                                        v-if="item.fl_definir_cobertura"
                                        v-model="item.fl_cobertura_atendimento" />
                                </div>

                                <div class="col col-12 col-md-5" v-if="item.fl_combo_pacote && item.fl_definir_cobertura">
                                    <az-input
                                        sizing="sm"
                                        class="mt-3"
                                        type="checkbox-group"
                                        label="Empacotar Mat/Med/Taxas de procedimentos não empacotados"
                                        v-model="item.fl_empacotar_consumos" />

                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Não Empacotar Procedimentos"
                                        v-if="item.fl_empacotar_consumos"
                                        v-model="item.fl_empacotar_apenas_consumos" />
                                </div>

                                <div class="col col-12 col-md-3" v-if="item.fl_combo_pacote && item.fl_definir_cobertura">
                                    <az-input
                                        sizing="sm"
                                        class="mt-3"
                                        type="checkbox-group"
                                        label="Repasse pelos itens empacotados"
                                        :edicao="item.fl_combo_pacote && item.fl_definir_cobertura"
                                        v-model="item.fl_repasse_empacotado" />
                                </div>
                            </div>

                            <div class="row" v-if="item.fl_combo_pacote && item.fl_definir_cobertura && item.fl_repasse_empacotado">
                                <div class="col col-12 offset-md-6 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Exceto para o profissional do pacote"
                                        v-model="item.fl_repasse_empacotado_exceto_medico" />
                                </div>
                            </div>
                            

                            <div class="small text-muted">
                                Deve ser marcado quando o pacote é para ser executado num instante, e possui cobertura para uma quantidade variada de procedimentos.
                            </div>

                            <template v-if="item.fl_definir_cobertura">

                                <!-- Filtros -->
                                <filtro-model 
                                    class="my-3" 
                                    v-model="item.filtros" 
                                    :validate="validate" 
                                    :opcoes="lista_opcoes_filtro" />

                                <br><br><br><br><br><br><br><br>

                            </template>

                            <template v-else>

                                <ul class="nav nav-tabs mt-2" id="myTab" role="tablist">
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Composição</a>
                                    </li>
                                    <li class="nav-item" role="presentation" v-if="item.pode_marcar && item.procedimento && item.procedimento.id_procedimento && item.procedimento.id_especialidade">
                                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Prestadores</a>
                                    </li>
                                    <li class="nav-item" role="presentation" v-if="item.pode_marcar && item.procedimento && item.procedimento.id_procedimento && item.procedimento.id_especialidade">
                                        <a class="nav-link" id="unidade-tab" data-toggle="tab" href="#unidade" role="tab" aria-controls="unidade" aria-selected="false">
                                            Unidades
                                            <span class="badge badge-secondary" v-if="item.unidades && item.unidades.filter(unidade => !unidade.excluido).length">
                                                {{ item.unidades.filter(unidade => !unidade.excluido).length }}
                                            </span>
                                        </a>
                                    </li>
                                    <li class="nav-item" role="presentation" v-if="item.procedimento && item.procedimento.id_procedimento">
                                        <a class="nav-link" id="classe-tab" data-toggle="tab" href="#classe" role="tab" aria-controls="classe" aria-selected="false">Classificação</a>
                                    </li>
                                </ul>

                                <div class="tab-content" id="myTabContent">
                                    <!-- Composição -->
                                    <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                        <div class="mt-3">
                                            <div class="form-row" v-for="(proc, ip) in lista_procedimentos" :key="ip">
                                                <div class="col col-12" :class="( proc.procedimento.amostras_count > 1 || proc.id_amostra_material || proc.procedimento.id_classe_procedimento == 19 ) ? ( item.fl_marcacao_combinada && proc.procedimento.id_classe_procedimento != 19 ? 'col-md-6' : 'col-md-4' ) : ( item.fl_marcacao_combinada ? 'col-md-9' : 'col-md-7' )">
                                                    <az-input 
                                                        sizing="sm"
                                                        icon="fas fa-minus fa-fw"
                                                        buttonText="fas fa-minus fa-fw"
                                                        :buttonIcon="true"
                                                        buttonColor="outline-danger"
                                                        v-model="proc.procedimento.search"
                                                        :edicao="false"
                                                        @clickButton="excluirProcedimento (proc)">
                                                        <template v-slot:buttonposb>
                                                            <div class="input-group-append" v-if="proc.procedimento.unidade_procedimento && !proc.procedimento.unidade_procedimento.fl_ativo">
                                                                <span class="input-group-text text-danger" id="basic-addon2">Inativo</span>
                                                            </div>
                                                        </template>
                                                    </az-input>
                                                </div>
                                                <div class="col col-12 col-md-4" v-if="proc.procedimento.id_classe_procedimento == 19">
                                                    <az-input   
                                                        sizing="sm"
                                                        placeholder="Observação"
                                                        v-model="proc.st_observacoes">
                                                    </az-input>
                                                </div>
                                                <div class="col col-12" :class="proc.procedimento.id_classe_procedimento == 19 ? 'col-md-1' : 'col-md-2'" v-if="!item.fl_marcacao_combinada || proc.procedimento.id_classe_procedimento == 19">
                                                    <az-input   
                                                        sizing="sm"
                                                        placeholder="Quantidade"
                                                        v-model="proc.in_quantidade">
                                                        <template v-slot:button-pre>
                                                            <div class="input-group-prepend" title="Quantidade">
                                                                <span class="input-group-text" id="basic-addon1">
                                                                    <i class="fa-solid fa-xmark"></i>
                                                                </span>
                                                            </div>
                                                        </template>
                                                    </az-input>
                                                </div>
                                                <div class="col col-12 col-md-3" v-if="proc.procedimento.amostras_count > 1 || proc.id_amostra_material">
                                                    <az-input
                                                        sizing="sm"
                                                        v-if="proc.amostra_material"
                                                        v-model="proc.amostra_material.search">
                                                        <template v-slot:buttonposb>
                                                            <div class="input-group-append">
                                                                <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="proc.amostra_material = null">
                                                                    <i class="fas fa-pen"></i>
                                                                </button>
                                                            </div>
                                                        </template>
                                                    </az-input>

                                                    <az-input
                                                        v-else
                                                        sizing="sm"
                                                        placeholder="Material..."
                                                        type="autocomplete" 
                                                        optionsMode="aql"
                                                        service="amostra_materiais.index"
                                                        optionsName="amostra_materiais.procedimento.index" 
                                                        :optionsParm="{ id_procedimento: proc.procedimento.id_procedimento }"
                                                        :optionsSync="true"
                                                        v-model="proc.amostra_material" />
                                                </div>
                                                <div class="col col-12 col-md-3">
                                                    <az-input   
                                                        sizing="sm"
                                                        type="select"
                                                        placeholder="Selecione..."
                                                        :optionsList="[
                                                            { id: 'T', search: 'Todas as Operadoras' },
                                                            { id: 'A', search: 'Apenas Operadoras' },
                                                            { id: 'E', search: 'Exceto Operadoras' },
                                                        ]"
                                                        optionsData="id"
                                                        v-model="proc.ch_escopo_operadora">
                                                        <template v-slot:buttonposb>
                                                            <div class="input-group-append" v-if="proc.ch_escopo_operadora == 'A' || proc.ch_escopo_operadora == 'E'">
                                                                <button class="btn btn-outline-primary" type="button" id="button-addon2" title="Definir operadoras" @click="editar_operadoras_comp(proc)">
                                                                    <i class="far fa-credit-card mr-1" aria-hidden="true"></i>
                                                                    <span class="badge badge-primary">
                                                                        {{ proc.operadoras.filter(item => !item.excluido).length }}
                                                                    </span>
                                                                </button>
                                                            </div>
                                                        </template>
                                                    </az-input>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <az-input 
                                                        sizing="sm"
                                                        placeholder="Procedimento"
                                                        icon="fas fa-plus"
                                                        type="autocomplete" 
                                                        optionsMode="aql"
                                                        optionsName="procedimentos.index" 
                                                        :optionsSync="true"
                                                        :optionsParm="{ com_amostras: true }"
                                                        service="procedimentos.index"
                                                        v-model="novoProcedimento"
                                                        ref="info_procedimento"
                                                        :procsigla="true"
                                                        @selecionado="incluirProcedimento ()" />
                                                </div>
                                            </div>

                                            <br><br><br><br><br><br><br><br>

                                        </div>
                                        
                                    </div>

                                    <!-- Prestadores -->
                                    <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab" v-if="item.procedimento">
                                        <selecao-prestadores-procedimentos 
                                            class="mt-3" 
                                            v-model="item.medicos" 
                                            :id_procedimento="item.procedimento.id_procedimento"
                                            @refresh="carregar_medicos(item)" />
                                    </div>

                                    <!-- Unidades -->
                                    <div class="tab-pane fade" id="unidade" role="tabpanel" aria-labelledby="unidade-tab">
                                        <div class="mt-3">
                                            <div class="form-row">
                                                <div class="col col-12 col-md-4">
                                                    <az-input
                                                        sizing="sm"
                                                        type="button-group"
                                                        :optionsList="[{id:1,search:'Apenas'}, {id:0,search:'Exceto'}]"
                                                        :validate="validate"
                                                        v-model="item.fl_unidade_regra" />
                                                </div>
                                                <div class="col col-12 col-md-8" v-if="!item.unidades.find(unidade => !unidade.excluido)">
                                                    <label class="form form-control form-control-sm mb-1">
                                                        Todas as Unidades
                                                    </label>
                                                </div>
                                            </div>
                                            <template v-for="(unidade, iux) in item.unidades">
                                                <div class="form-row" :key="iux" v-show="!unidade.excluido" v-if="true">
                                                    <div class="col col-12">
                                                        <az-input 
                                                            sizing="sm"
                                                            icon="fas fa-minus fa-fw"
                                                            buttonText="fas fa-minus fa-fw"
                                                            :buttonIcon="true"
                                                            buttonColor="outline-danger"
                                                            v-model="unidade.search"
                                                            :edicao="false"
                                                            @clickButton="unidade.excluido = true">
                                                        </az-input>
                                                    </div>
                                                </div>
                                            </template>

                                            <div class="row">
                                                <div class="col">
                                                    <az-input 
                                                        sizing="sm"
                                                        placeholder="Selecione a Unidade..."
                                                        icon="fas fa-plus fa-fw"
                                                        type="select" 
                                                        :optionsList="$util.unidades_com_tags(false, false)"
                                                        v-model="novaUnidade"
                                                        ref="info_unidade"
                                                        @input="incluir_unidade ()" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Prestadores -->
                                    <div class="tab-pane fade" id="classe" role="tabpanel" aria-labelledby="classe-tab" v-if="item.procedimento && item.procedimento.id_procedimento">
                                        <div class="row mt-3">
                                            <div class="col col-12">
                                                <multiselect
                                                    v-model="item.procedimento.js_classes"
                                                    :options="options_classes"
                                                    :multiple="true"
                                                    :taggable="true"
                                                    @tag="addTag"
                                                    placeholder="Selecione uma classificação..."
                                                    selectLabel="Pressione [ENTER] para selecionar"
                                                    deselectLabel="Pressione [ENTER] para remover"
                                                    tagPlaceholder="Pressione [ENTER] para incluir"
                                                    selectedLabel="Selecionado">
                                                    <template slot="noOptions">
                                                        Nenhuma classificação criada.
                                                    </template>
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </template>

                        </template>
                        
                    </div>
                    <div class="modal-footer" v-if="item">
                        <button class="btn btn-outline-secondary" 
                            @click="$util.logAudit('pacote', item.id_pacote)"
                            v-if="item.id_pacote">
                            Log
                        </button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">{{ item && item.id_pacote ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal de Operadoras para a Composição -->
        <div class="modal fade" id="composicaoOperadoraModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="edicao_comp">
                    <div class="modal-header">
                        <h5 class="modal-title">Configurações por Operadora</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <h5 class="text-primary">{{ edicao_comp.procedimento.search }}</h5>

                        <template v-for="(cpo, icpo) in edicao_comp.operadoras">
                            <div class="row" :key="icpo" v-if="!cpo.excluido">
                                <div class="col col-12">
                                    <az-input
                                        icon="fa fa-minus fa-fw"
                                        :buttonIcon="true"
                                        buttonColor="outline-danger"
                                        buttonText="fa fa-minus fa-fw"
                                        @clickButton="cpo.excluido = true"
                                        :edicao="false"
                                        v-if="cpo.id_plano"
                                        v-model="cpo.plano.search">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">P</span>
                                            </div>
                                        </template>
                                    </az-input>

                                    <az-input
                                        icon="fa fa-minus fa-fw"
                                        :buttonIcon="true"
                                        buttonColor="outline-danger"
                                        buttonText="fa fa-minus fa-fw"
                                        @clickButton="cpo.excluido = true"
                                        :edicao="false"
                                        v-else
                                        v-model="cpo.operadora.search">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">O</span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                            </div>
                        </template>

                        <div class="row mt-2">
                            <div class="col">
                                <az-input
                                    type="button-group"
                                    :optionsList="[
                                        { id: 'O', search: 'Operadora' },
                                        { id: 'P', search: 'Plano' }
                                    ]"
                                    optionsData="id"
                                    optionsDisplay="search"
                                    v-model="novaOperadoraTipo" />
                            </div>
                        </div>

                        <div class="row mt-2" v-if="novaOperadoraTipo == 'O'">
                            <div class="col">
                                <az-input
                                    icon="fa fa-plus fa-fw"
                                    label="Operadora"
                                    type="autocomplete"
                                    optionsMode="aql"
                                    optionsName="operadoras.index"
                                    service="operadoras.index"
                                    :optionsSync="true"
                                    v-model="novaOperadoraComp"
                                    @input="incluirOperadoraComp ()" />
                            </div>
                        </div>

                        <div class="row mt-2" v-else-if="novaOperadoraTipo == 'P'">
                            <div class="col">
                                <az-input
                                    icon="fa fa-plus fa-fw"
                                    label="Particular"
                                    type="autocomplete"
                                    optionsMode="aql"
                                    optionsName="planos.index"
                                    :optionsSync="false"
                                    service="planos.index"
                                    @input="incluirOperadoraPlanoComp ()"
                                    v-model="novaOperadoraPlanoComp" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="confirmarConfiguracaoPorOperadora ()">OK</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzWiki from '../../util/AzWiki.vue';
import FiltroModel from '../shared/FiltroModel.vue';
import SelecaoPrestadoresProcedimentos from '../shared/SelecaoPrestadoresProcedimentos.vue';
import Importacao from '../shared/Importacao.vue';
import Multiselect from 'vue-multiselect';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            procedimentos: null, 
            validate: false,
            especialidade: null,
            search: "", 
            viewMode: "A",
            novoProcedimento: null, 
            pacoteNovaOperadora: "", 
            novaOperadoraTipo: "O", 
            novaOperadoraComp: null, 
            novaOperadoraPlanoComp: null, 
            edicao_comp: null, 
            pp: null, 
            novaUnidade: "", 
            selecionado: null, 
            options_classes: [],
        }
    },

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzSubTitle,
        AzWiki,
        FiltroModel,
        SelecaoPrestadoresProcedimentos, 
        Importacao, 
        Multiselect, 
    },

    watch: { 
        especialidade: function () { 
            this.load ();
        }
    },
    
    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                })
                .sort((a, b) => { 
                    return a.search > b.search ? 1 : -1 ;
                }) : null;
        },

        lista_procedimentos: function () { 
            if ( !this.item ) 
                return [];

            return this.item.procedimento_pacotes.filter (i => { 
                return !i.excluido;
            });
        },

        lista_opcoes_filtro: function () { 
            let opcoes = [                        
                {id:'tag-material', search:'Classificação do Material', service: 'materiais.index', parms: { ativos: true }, tag: true}, 
                {id:'tag-medicamento', search:'Classificação do Medicamento', service: 'medicamentos.index', parms: { ativos: true }, tag: true}, 
                {id:'tag-taxa', search:'Classificação da Taxa', service: 'taxas.index', parms: { ativos: true }, tag: true}, 
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\grauParticipacao', search:'Grau de Participação', service: 'grau_participacoes.index' },
                {id:'App\\azure\\material', search:'Material', service: 'materiais.index', parms: { ativos: true }},
                {id:'App\\azure\\medicamento', search:'Medicamento', service: 'medicamentos.index', parms: { ativos: true }},
                {id:'App\\azure\\taxa', search:'Taxa', service: 'taxas.index', parms: { ativos: true }},
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
                {id:'App\\azure\\recepcao', search:'Recepção', service: 'recepcaos.index', parms: { filtros: true }},
            ];

            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade', service:'unidade_operacaos.index'});
            }
            
            return opcoes;
        }

    },

    methods: { 
        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.procedimento.js_classes )
                this.item.procedimento.js_classes = [];

            this.item.procedimento.js_classes.push(newTag);
        },

        onArrowDown () { 
            if ( this.selecionado === null ) {
                this.selecionado = 0;
            } else { 
                this.selecionado ++;
            }
		},

		onArrowUp () { 
			if ( this.selecionado > 0 ) { 
				this.selecionado --;
			}			
		},

		onEnter () { 
            if ( _.get(this.lista, this.selecionado) ) { 
                this.editar(this.lista[this.selecionado])
            }
        },

        incluir_unidade() { 
            if ( !this.novaUnidade ) { 
                return;
            }

            if ( this.item.unidades.find(unidade => unidade.id_unidade_operacao == this.novaUnidade.id_unidade_operacao && !unidade.excluido) ) { 
                
                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: 'Unidade já selecionada: ' + this.novaUnidade.st_nome,
                    life: 3000
                });
                
            } else { 

                this.item.unidades.push({ 
                    id_pacote_unidade_operacao: null, 
                    id_pacote: this.item.id_pacote, 
                    id_unidade_operacao: this.novaUnidade.id_unidade_operacao,
                    search: this.novaUnidade.st_nome, 
                    excluido: false, 
                });

            }   

            this.novaUnidade = null;

            this.$nextTick(() => { 
                this.novaUnidade = "";
            });
        },

        confirmarConfiguracaoPorOperadora () { 
            this.pp.operadoras = this.edicao_comp.operadoras;
            $('#composicaoOperadoraModal').modal('hide');
        },

        incluirOperadoraComp () {
            if ( !this.novaOperadoraComp )
                return;

            this.edicao_comp.operadoras.push({
                id_procedimento_pacote: null,
                id_procedimento_pacote_operadora: null,
                id_operadora: this.novaOperadoraComp.id_operadora,
                excluido: false,
                operadora: {
                    search: this.novaOperadoraComp.search,
                }
            });

            this.novaOperadoraComp = "";

            this.$nextTick(() => {
                this.novaOperadoraComp = null;
            });

        },

        incluirOperadoraPlanoComp () {
            if ( !this.novaOperadoraPlanoComp )
                return;

            this.edicao_comp.operadoras.push({
                id_procedimento_pacote: null,
                id_procedimento_pacote_operadora: null,
                id_operadora: this.novaOperadoraPlanoComp.id_operadora,
                id_plano: this.novaOperadoraPlanoComp.id_plano,
                excluido: false,
                operadora: {
                    search: this.novaOperadoraPlanoComp.search,
                },
                plano: {
                    search: this.novaOperadoraPlanoComp.search,
                }
            });

            this.novaOperadoraPlanoComp = "";

            this.$nextTick(() => {
                this.novaOperadoraPlanoComp = null;
            });

        },

        editar_operadoras_comp (pp) { 
            this.pp = pp;
            this.edicao_comp = _.cloneDeep(pp);
            $('#composicaoOperadoraModal').modal('show');
        },

        clonar_combo(combo) { 
            this.validate = false;
            this.item = null; 

            $('#edicaoModal').modal('show');

            this.$nextTick(() => { 

                this.$util.load(this, { 
                    service: 'pacotes',
                    func: 'index',
                    parms: { 
                        where: { 
                            id_pacote: combo.id_pacote
                        }, 
                        cadastro_combo: true, 
                    },
                    loadTo: res => { 
                        if ( res && res.length == 1 ) { 
                            res[0].medicos = [];

                            res[0].id_pacote = null;
                            res[0].procedimento.id_procedimento = null; 
                            res[0].procedimento.st_procedimento = "(Novo) " + res[0].procedimento.st_procedimento;

                            res[0].filtros.forEach(item => { 
                                item.id_pacote_filtro = null;
                            });

                            res[0].procedimento_pacotes.forEach(item => { 
                                item.id_procedimento_pacote = null;
                            });

                            if ( res[0].pacote_operadoras ) { 
                                res[0].pacote_operadoras.forEach(item => { 
                                    item.id_pacote_operadora = null;
                                });
                            }

                            this.item = res[0];
                        }
                    }
                });

            });

            /*            

            item.id_pacote = null;
            item.procedimento.id_procedimento = null; 
            item.procedimento.st_procedimento = "(Novo) " + item.procedimento.st_procedimento;

            item.filtros.forEach(item => { 
                item.id_pacote_filtro = null;
            });

            item.procedimento_pacotes.forEach(item => { 
                item.id_procedimento_pacote = null;
            });

            if ( item.pacote_operadoras ) { 
                item.pacote_operadoras.forEach(item => { 
                    item.id_pacote_operadora = null;
                });
            }
            
            this.editar (item);

            */
        },

        adicionarOperadora () { 

            if ( this.pacoteNovaOperadora ) { 
                
                this.item.pacote_operadoras.push({
                    id_pacote_operadora: null, 
                    id_pacote: this.item.id_pacote,
                    id_operadora: this.pacoteNovaOperadora.id_operadora,
                    search: this.pacoteNovaOperadora.search,
                    selecionado: true, 
                });

                this.$nextTick (() => { 
                    this.pacoteNovaOperadora =  "";
                });

            }

        },

        incluirProcedimento () { 
            if ( Array.isArray(this.novoProcedimento) ) { 
                let lista = _.cloneDeep(this.novoProcedimento);

                lista.forEach(proc => { 
                    this.novoProcedimento = proc;
                    this.incluirProcedimento();
                });
                return;
            }

            if ( this.novoProcedimento ) { 

                let novo = _.cloneDeep(this.novoProcedimento);

                this.item.procedimento_pacotes.push({ 
                    id_pacote: this.item.id_pacote, 
                    id_procedimento_pacote: null, 
                    id_procedimento: novo.id_procedimento,
                    in_quantidade: 1,
                    procedimento: novo,
                    excluido: false, 
                    ch_escopo_operadora: "T",
                    operadoras: [], 
                });

                this.$nextTick (() => { 
                    this.novoProcedimento = null;
                });

            }
        },
        excluirProcedimento (proc) { 
            proc.excluido = true;

            this.$nextTick(() => { 
                this.$forceUpdate();
            });
        },
        incluir () { 
            this.validate = false;

            let item = {
                id_pacote: null, 
                dc_valor: 0, 
                fl_ativo: true,
                fl_combo: true,
                fl_combo_pacote: false, 
                fl_particular: false,
                fl_cobranca_total: true, 
                fl_definir_cobertura: false, 
                fl_empacotar_consumos: false, 
                in_validade_dias: 30, 
                procedimento_pacotes: [],
                procedimento: { 
                    id_procedimento: null, 
                    st_procedimento: "", 
                },
                filtros: [], 
                unidades: [], 
            };

            this.item = item;
            this.validate = false;

            $('#edicaoModal').modal('show');
        },
        load () { 
            this.$store.commit('loading', true);

            let query = { q: [
                { 
                    name: 'pacotes.index',
                    id: 'lista',
                    parms: { 
                        where: { fl_combo: true },
                        cadastro: true, 
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.lista.status == 200 ) { 
                        this.dados = res.data.lista.data;
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });
        },

        carregar_medicos (item) { 

            if ( item.procedimento ) { 

                this.$store.commit('loading', true);

                let query = { q: [
                    { 
                        name: 'medico_unidades.index',
                        id: 'medicos',
                        parms: { 
                            id_procedimento: item.procedimento.id_procedimento,
                            id_especialidade: item.procedimento.id_especialidade, 
                        }
                    },
                ]};

                this.axios.post('/aql?a=medico_unidades.index', query)
                    .then(res => { 
                        if ( res.data.medicos.status == 200 ) { 
                            let lista = res.data.medicos.data;

                            lista.forEach(element => {
                                if ( !element.medico_procedimento_unidade ) 
                                    element.medico_procedimento_unidade = { 
                                        fl_ativo: false,
                                        id_procedimento: item.procedimento.id_procedimento,
                                    };
                            });

                            item.medicos = lista;
                        }
                    })
                    .finally(() => { 
                        this.$store.commit('loading', false);
                    });

            }

        },

        editar (item) { 
            this.item = null;
            this.validate = false;

            $('#edicaoModal').modal('show');

            this.$nextTick(() => { 

                this.$util.load(this, { 
                    service: 'pacotes',
                    func: 'index',
                    parms: { 
                        where: { 
                            id_pacote: item.id_pacote
                        }, 
                        cadastro_combo: true, 
                    },
                    loadTo: res => { 
                        if ( res && res.length == 1 ) { 
                            res[0].medicos = [];

                            this.item = res[0];    
                        }
                    }
                });

                //item.medicos = [];
                //this.item = _.cloneDeep (item);

                // this.carregar_medicos(this.item);

                //$('#edicaoModal').modal('show');
            });
        },
        atualizar () { 

            if ( !this.item.procedimento_pacotes.length && !this.item.fl_definir_cobertura ) { 

                this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Necessário informar os itens do combo de procedimentos.",
                        life: 3000
                    });

                return;
                
            } else if ( this.item.procedimento_pacotes.length && this.item.fl_definir_cobertura ) { 

                this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Composição definida indevidamente.",
                        life: 3000
                    });

                return;

            }

            this.$util.atualizar(this, { 
                service: 'pacotes',
                dados: this.item,
                modal: 'edicaoModal', 
                toast: true, 
                reload: true, 
            });

            this.$util.atualizar(this, { 
                service: 'medico_unidades',
                func: 'update_procedimento',
                dados: this.item.medicos, 
            });

            /*
            this.validate = true;

            this.$nextTick (() => { 

                let invalids = $('.invalid');

                if ( invalids.length ) { 
                   
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Verificar preenchimento dos campos.",
                        life: 3000
                    });

                } else { 

                    this.$store.commit('loading', true);

                    let query = { q: [ 
                        { 
                            name: 'pacotes.store',
                            id: 'atualizar',
                            parms: { 
                                ...this.item,
                            }
                        }
                    ]};
                    
                    this.axios.post('/aql', query)
                        .then (res => { 
                            if ( res.data.atualizar.status == 200 ) { 
                                $('#edicaoModal').modal('hide');
                                this.load();

                                this.$toast.add({
                                        severity: "success",
                                        summary: "Atenção",
                                        detail: "Cadastro atualizado.",
                                        life: 3000
                                    });
                            }
                        })
                        .finally(() => { 
                            this.$store.commit('loading', false);
                        });

                }

            });
            */

        },
        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$store.commit('loading', true);

            let query = { q: [ 
                { 
                    name: 'pacotes.toggle',
                    id: 'toggle',
                    parms: { 
                        ...item,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.toggle.status == 200 ) { 
                        //
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

        },
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    mounted () { 
        this.$refs['pesquisa'].$refs.input.focus ();

        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Combo de Procedimentos", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.$util.loadItem(this, { 
            service: 'procedimentos',
            func: 'tags',
        })
        .then(res => { 
            this.options_classes = res;
        });

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>